module.exports = "pegasus/assets/tech/birthday/100.png";